export class GenericCatalogModel {
    description: string | number

    constructor(
        description: string | number
    ) {
        this.description = description
    }
}